import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = {
  itemCount: {
    width: '150px'
  },
  title: {
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose();

const Main = enhance(({ dataTitle, dataValue, small = false, classes }) => {
  return (
    <div className={classes.itemCount}>
      <Typography
        component="h2"
        variant={small ? 'subtitle1' : 'h6'}
        color="textSecondary"
        className={classes.title}
      >
        {dataTitle.split('<br/>').map(item => {
          return (
            <span>
              {item}
              <br />
            </span>
          );
        })}
      </Typography>
      <Typography
        component="p"
        variant={small ? 'h5' : 'h4'}
        color="textSecondary"
      >
        {dataValue ? dataValue.toLocaleString() : dataValue}
      </Typography>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
